var _rect, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAgenciesOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.74998 5.10001C4.28642 5.10001 3.09998 6.28645 3.09998 7.75001C3.09998 9.21356 4.28642 10.4 5.74998 10.4H7.24998C8.71353 10.4 9.89998 9.21356 9.89998 7.75001C9.89998 6.28645 8.71353 5.10001 7.24998 5.10001H5.74998ZM4.89998 7.75001C4.89998 7.28056 5.28053 6.90001 5.74998 6.90001H7.24998C7.71942 6.90001 8.09998 7.28056 8.09998 7.75001C8.09998 8.21945 7.71942 8.60001 7.24998 8.60001H5.74998C5.28053 8.60001 4.89998 8.21945 4.89998 7.75001Z",
    fill: "var(--primary-6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09998 15C3.09998 13.3984 4.39835 12.1 5.99998 12.1H6.99998C8.6016 12.1 9.89998 13.3984 9.89998 15V18C9.89998 19.6016 8.6016 20.9 6.99998 20.9H5.99998C4.39835 20.9 3.09998 19.6016 3.09998 18V15ZM5.99998 13.9C5.39246 13.9 4.89998 14.3925 4.89998 15V18C4.89998 18.6075 5.39246 19.1 5.99998 19.1H6.99998C7.60749 19.1 8.09998 18.6075 8.09998 18V15C8.09998 14.3925 7.60749 13.9 6.99998 13.9H5.99998Z",
    fill: "var(--primary-6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 16.1C15.1745 16.1 14.1 17.1745 14.1 18.5C14.1 19.8255 15.1745 20.9 16.5 20.9H18.5C19.8255 20.9 20.9 19.8255 20.9 18.5C20.9 17.1745 19.8255 16.1 18.5 16.1H16.5ZM15.9 18.5C15.9 18.1686 16.1686 17.9 16.5 17.9H18.5C18.8313 17.9 19.1 18.1686 19.1 18.5C19.1 18.8314 18.8313 19.1 18.5 19.1H16.5C16.1686 19.1 15.9 18.8314 15.9 18.5Z",
    fill: "var(--primary-6)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5851 2.8075C12.4258 3.06156 13 3.82813 13 4.69654V9.56035L22.5851 12.5444C23.4259 12.8016 24 13.5777 24 14.4569V22C24 23.1046 23.1046 24 22 24H2C0.895431 24 0 23.1156 0 22.0245V1.97681C0 0.64902 1.29965 -0.30069 2.58511 0.0877658L11.5851 2.8075ZM2.05851 1.7879L11.0585 4.50764C11.1426 4.53304 11.2 4.6097 11.2 4.69654V22.2221H2C1.88954 22.2221 1.8 22.1336 1.8 22.0245V1.97681C1.8 1.84403 1.92997 1.74906 2.05851 1.7879ZM13.0001 11.4331L22.0585 14.2656C22.1426 14.2914 22.2 14.369 22.2 14.4569V22C22.2 22.1105 22.1105 22.2 22 22.2H13.0001V11.4331Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgenciesOutlined);
export default __webpack_public_path__ + "static/media/agenciesOutlined.fdbd1ff4304d6179803aee783f8b6ccd.svg";
export { ForwardRef as ReactComponent };